module.exports = __webpack_public_path__ + "img/cert.32481e7b.png";